var map = {
	"./present-0@2x.png": [
		12047,
		7497
	],
	"./present-1@2x.png": [
		12048,
		7498
	],
	"./present-2@2x.png": [
		12049,
		7499
	],
	"./present-3@2x.png": [
		12050,
		7500
	],
	"./present-4@2x.png": [
		12051,
		7501
	],
	"./present-5@2x.png": [
		12052,
		7502
	],
	"./present-ribbon@2x.png": [
		1112
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1103;
module.exports = webpackAsyncContext;